import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const OrderLink = styled.a`
  color: #efb348; /* Match PriceBoard header color */
  text-decoration: none;
  font-weight: bold;
  cursor: pointer;
  margin-left: 8px;

  &:hover {
    color: #81d4fa;
    text-decoration: underline;
  }
`;

const Order = () => {
  const { t } = useTranslation();
  return (
    <OrderLink
      href="https://form.jotform.com/221722338922858"
      target="_blank"
      rel="noopener noreferrer"
    >
      {t('order.linkText')}
    </OrderLink>
  );
};

export default Order;
